/* =========================================================
   Raw theme – scripts
   ========================================================= */
(function () {
  'use strict';

  var theme = window.theme || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', cartJs: '/cart.js' }, strings: {} };

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || theme.moneyFormat || '${{amount}}';

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
  }

  function lockScroll(lock) {
    document.body.classList.toggle('is-locked', lock);
  }

  /* ---------- Drawers ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    lockScroll(true);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.menu-drawer.is-open, .cart-drawer.is-open')) lockScroll(false);
  }

  function cartDrawer() { return document.querySelector('[data-cart-drawer]'); }
  function menuDrawer() { return document.querySelector('[data-menu-drawer]'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openDrawer(menuDrawer());
      var t = document.querySelector('[data-menu-open]');
      if (t) t.setAttribute('aria-expanded', 'true');
      return;
    }
    if (e.target.closest('[data-menu-close]')) {
      closeDrawer(menuDrawer());
      var t2 = document.querySelector('[data-menu-open]');
      if (t2) t2.setAttribute('aria-expanded', 'false');
      return;
    }
    if (e.target.closest('[data-cart-open]') && theme.cartType === 'drawer' && cartDrawer()) {
      e.preventDefault();
      openDrawer(cartDrawer());
      return;
    }
    if (e.target.closest('[data-cart-close]')) {
      closeDrawer(cartDrawer());
      return;
    }
    var lineBtn = e.target.closest('[data-line-change]');
    if (lineBtn) {
      e.preventDefault();
      changeLine(parseInt(lineBtn.getAttribute('data-line-change'), 10), parseInt(lineBtn.getAttribute('data-qty'), 10));
      return;
    }
    var accToggle = e.target.closest('[data-accordion-toggle]');
    if (accToggle) {
      var item = accToggle.closest('[data-accordion]');
      var open = !item.classList.contains('is-open');
      // Only one open item per group: opening one closes the others
      if (open) {
        var group = item.closest('[data-accordion-group], .product__info, .store-faq__list') || document;
        group.querySelectorAll('[data-accordion].is-open').forEach(function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var t = other.querySelector('[data-accordion-toggle]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
      item.classList.toggle('is-open', open);
      accToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var recover = e.target.closest('[data-toggle-recover]');
    if (recover) {
      e.preventDefault();
      var r = document.getElementById('RecoverPassword');
      var l = document.getElementById('CustomerLogin');
      if (r && l) { r.hidden = !r.hidden; l.hidden = !r.hidden ? true : false; }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawer(menuDrawer());
      closeDrawer(cartDrawer());
    }
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  }

  function refreshCart() {
    var url = theme.routes.root + (theme.routes.root.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer';
    return Promise.all([
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetch(theme.routes.cartJs, { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0] && res[0]['cart-drawer'];
      var current = cartDrawer();
      if (html && current) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          current.className = fresh.className + (wasOpen ? ' is-open' : '');
        }
      }
      updateCartCount(res[1].item_count);
      return res[1];
    });
  }

  function changeLine(line, quantity) {
    var drawer = cartDrawer();
    if (drawer) drawer.classList.add('is-loading');
    fetch(theme.routes.cartChange + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
    })
      .then(function () { return refreshCart(); })
      .catch(function () {})
      .then(function () { if (drawer) drawer.classList.remove('is-loading'); });
  }

  function addItems(items) {
    return fetch(theme.routes.cartAdd + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) {
          throw new Error(data.description || data.message || theme.strings.error);
        }
        return data;
      });
    });
  }

  function afterAdd(action) {
    if (action === 'checkout') {
      window.location.href = '/checkout';
      return Promise.resolve();
    }
    if (action === 'cart' || theme.cartType !== 'drawer' || !cartDrawer()) {
      window.location.href = theme.routes.cart;
      return Promise.resolve();
    }
    return refreshCart().then(function () { openDrawer(cartDrawer()); });
  }

  /* ---------- Announcement rotator ---------- */
  document.querySelectorAll('[data-announcement].is-rotating').forEach(function (track) {
    var items = track.querySelectorAll('.announcement-bar__item');
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  });

  /* =========================================================
     Product section
     ========================================================= */
  function ProductSection(root) {
    this.root = root;
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    try { this.product = JSON.parse(json.textContent); } catch (err) { return; }

    this.form = root.querySelector('form.product-form');
    this.idInput = root.querySelector('[data-variant-id]');
    this.addButton = root.querySelector('[data-add-button]');
    this.addLabel = root.querySelector('[data-add-label]');
    this.errorEl = root.querySelector('[data-form-error]');
    this.priceEl = root.querySelector('[data-product-price]');
    this.picker = root.querySelector('[data-variant-picker]');
    this.bundle = root.querySelector('[data-bundle]');
    this.swatches = root.querySelector('[data-color-swatches]');
    this.colorIndex = parseInt(root.getAttribute('data-color-index'), 10);
    if (isNaN(this.colorIndex)) this.colorIndex = -1;
    this.filterByColor = root.getAttribute('data-filter-media') === 'true' && this.colorIndex >= 0;
    // 'preview' = swatches only change the photos; 'select' = swatches choose the variant
    this.swatchMode = this.swatches ? (this.swatches.getAttribute('data-swatch-mode') || 'preview') : 'select';

    var startId = this.idInput ? parseInt(this.idInput.value, 10) : null;
    this.currentVariant = this.variantById(startId) || this.product.variants[0];
    this.currentOptions = this.currentVariant ? this.currentVariant.options.slice() : [];
    this.previewedColor = this.currentColor();

    this.initGallery();
    this.initSwatches();
    this.initPicker();
    this.initQuantity();
    this.initBundle();
    this.initForm();
  }

  ProductSection.prototype.findVariant = function (options) {
    return this.product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === options[i]; });
    });
  };

  ProductSection.prototype.variantById = function (id) {
    return this.product.variants.find(function (v) { return v.id === id; });
  };

  ProductSection.prototype.currentColor = function () {
    return this.colorIndex >= 0 ? this.currentOptions[this.colorIndex] : null;
  };

  /* ---------- Gallery (no thumbnails, arrows on the image, loops) ---------- */
  ProductSection.prototype.initGallery = function () {
    var self = this;
    this.gallery = this.root.querySelector('[data-gallery]');
    this.main = this.root.querySelector('[data-gallery-main]');
    this.slides = this.main ? Array.prototype.slice.call(this.main.querySelectorAll('.product-gallery__slide')) : [];
    if (!this.main || this.slides.length === 0) return;

    var prev = this.root.querySelector('[data-gallery-prev]');
    var next = this.root.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { self.step(-1); });
    if (next) next.addEventListener('click', function () { self.step(1); });

    this.main.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.step(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self.step(1); }
    });

    window.addEventListener('resize', function () {
      // keep the current image aligned after a rotation / resize
      self.goToSlide(self.lastIndex || 0, false);
    });

    var ticking = false;
    this.main.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        self.lastIndex = self.currentIndex();
        ticking = false;
      });
    }, { passive: true });

    this.updateArrows();

    var active = this.main.querySelector('.product-gallery__slide.is-active:not([hidden])');
    var idx = active ? this.visibleSlides().indexOf(active) : 0;
    this.goToSlide(Math.max(0, idx), false);
  };

  ProductSection.prototype.visibleSlides = function () {
    return this.slides.filter(function (s) { return !s.hidden; });
  };

  ProductSection.prototype.currentIndex = function () {
    if (!this.main) return 0;
    var count = this.visibleSlides().length;
    var i = Math.round(this.main.scrollLeft / Math.max(1, this.main.clientWidth));
    return Math.max(0, Math.min(count - 1, i));
  };

  ProductSection.prototype.goToSlide = function (index, smooth) {
    if (!this.main) return;
    var count = this.visibleSlides().length;
    if (count === 0) return;
    index = Math.max(0, Math.min(count - 1, index));
    this.lastIndex = index;
    var left = this.main.clientWidth * index;
    if (smooth === false) {
      this.main.style.scrollBehavior = 'auto';
      this.main.scrollLeft = left;
      this.main.style.scrollBehavior = '';
    } else {
      this.main.scrollTo({ left: left, behavior: 'smooth' });
    }
  };

  // Circular navigation: after the last image comes the first, and the other way round
  ProductSection.prototype.step = function (direction) {
    var count = this.visibleSlides().length;
    if (count < 2) return;
    var next = (this.currentIndex() + direction + count) % count;
    this.goToSlide(next, true);
  };

  ProductSection.prototype.updateArrows = function () {
    if (!this.gallery) return;
    this.gallery.classList.toggle('is-single', this.visibleSlides().length < 2);
  };

  ProductSection.prototype.goToMedia = function (mediaId, smooth) {
    if (!mediaId || !this.slides) return false;
    var visible = this.visibleSlides();
    for (var i = 0; i < visible.length; i++) {
      if (String(visible[i].getAttribute('data-media-id')) === String(mediaId)) {
        this.goToSlide(i, smooth);
        return true;
      }
    }
    return false;
  };

  // Show only the images of the selected color (falls back to all images if none match)
  ProductSection.prototype.filterGallery = function (color) {
    if (!this.filterByColor || !this.main) return;
    var matching = this.slides.filter(function (s) { return s.getAttribute('data-media-color') === color; });
    var showAll = matching.length === 0;
    this.slides.forEach(function (s) {
      s.hidden = !(showAll || s.getAttribute('data-media-color') === color);
    });
    this.updateArrows();
    this.goToSlide(0, false);
  };

  /* ---------- Color swatches ---------- */
  ProductSection.prototype.initSwatches = function () {
    var self = this;
    if (!this.swatches || this.colorIndex < 0) return;
    this.swatchButtons = Array.prototype.slice.call(this.swatches.querySelectorAll('[data-color-value]'));
    this.swatchLabel = this.swatches.querySelector('[data-color-label]');

    this.swatchButtons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        self.setColor(btn.getAttribute('data-color-value'), 'swatch');
      });
      btn.addEventListener('keydown', function (e) {
        var dir = 0;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') dir = 1;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') dir = -1;
        if (!dir) return;
        e.preventDefault();
        var target = self.swatchButtons[(i + dir + self.swatchButtons.length) % self.swatchButtons.length];
        target.focus();
        self.setColor(target.getAttribute('data-color-value'), 'swatch');
      });
    });
  };

  ProductSection.prototype.updateSwatchesUI = function (color) {
    if (!this.swatchButtons) return;
    this.swatchButtons.forEach(function (btn) {
      var on = btn.getAttribute('data-color-value') === color;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.setAttribute('tabindex', on ? '0' : '-1');
    });
    if (this.swatchLabel) this.swatchLabel.textContent = color;
  };

  // Show a color (swatches + photos) without touching what will be added to the cart
  ProductSection.prototype.previewColor = function (color) {
    if (this.colorIndex < 0 || color == null) return false;
    this.updateSwatchesUI(color);
    var changed = this.previewedColor !== color;
    this.previewedColor = color;
    if (changed) this.filterGallery(color);
    return changed;
  };

  // Color change coming from the swatches (in "select" mode) or from the standard variant picker
  ProductSection.prototype.setColor = function (color, source) {
    if (this.colorIndex < 0 || color == null) return;
    if (source === 'swatch' && this.swatchMode === 'preview') {
      this.previewColor(color);
      return;
    }
    var changed = this.previewColor(color);
    this.currentOptions[this.colorIndex] = color;

    if (this.bundle && source === 'swatch') {
      var self = this;
      var hideColor = !!this.bundle.querySelector('.select-wrap[hidden] [data-row-option="' + this.colorIndex + '"]');
      this.tiers.forEach(function (tier) {
        tier.querySelectorAll('[data-bundle-row]').forEach(function (row, rowIndex) {
          // when each item has its own visible color select, only the first row follows the swatches
          if (!hideColor && rowIndex > 0) return;
          var sel = row.querySelector('[data-row-option="' + self.colorIndex + '"]');
          if (sel) sel.value = color;
          self.updateRow(row);
        });
      });
    }

    this.refreshVariant(changed);
  };

  /* ---------- Standard variant picker ---------- */
  ProductSection.prototype.initPicker = function () {
    var self = this;
    if (!this.picker) return;
    this.picker.addEventListener('change', function (e) {
      var input = e.target.closest('[data-option-index]');
      if (!input) return;
      var i = parseInt(input.getAttribute('data-option-index'), 10);
      var label = self.picker.querySelector('[data-option-label="' + i + '"]');
      if (label) label.textContent = input.value;
      if (i === self.colorIndex) {
        self.setColor(input.value, 'picker');
      } else {
        self.currentOptions[i] = input.value;
        self.refreshVariant(false);
      }
    });
  };

  // Recompute the active variant from the current options and update price, stock, button, image
  ProductSection.prototype.refreshVariant = function (colorChanged) {
    if (this.bundle) {
      var self = this;
      this.tiers.forEach(function (t) { self.updateTier(t); });
      this.updateBundleButton();
      var tier = this.bundle.querySelector('[data-bundle-tier].is-selected');
      var firstRow = tier && tier.querySelector('[data-bundle-row]');
      var v = firstRow ? this.rowVariant(firstRow) : this.findVariant(this.currentOptions);
      if (v) {
        this.currentVariant = v;
        this.updatePrice(v);
        this.updateUrl(v);
        if (v.featured_media && !colorChanged) this.goToMedia(v.featured_media.id, true);
      }
      return;
    }
    this.onVariantChange(this.findVariant(this.currentOptions), colorChanged);
  };

  ProductSection.prototype.onVariantChange = function (variant, colorChanged) {
    if (!variant) {
      this.setButton(false, theme.strings.unavailable);
      return;
    }
    this.currentVariant = variant;
    if (this.idInput) this.idInput.value = variant.id;
    this.setButton(variant.available, variant.available ? null : theme.strings.soldOut);
    this.updatePrice(variant);
    if (variant.featured_media) this.goToMedia(variant.featured_media.id, !colorChanged);
    this.updateUrl(variant);
  };

  ProductSection.prototype.updatePrice = function (variant) {
    if (!this.priceEl || !variant) return;
    var onSale = variant.compare_at_price > variant.price;
    this.priceEl.innerHTML = '<div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
      '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
      (onSale ? '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' : '') +
      '</div>';
  };

  ProductSection.prototype.updateUrl = function (variant) {
    if (!window.history || !window.history.replaceState || !variant) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  };

  ProductSection.prototype.setButton = function (enabled, text) {
    if (!this.addButton) return;
    this.addButton.disabled = !enabled;
    if (this.addLabel) this.addLabel.textContent = text || this.addButton.getAttribute('data-label');
  };

  /* ---------- Quantity ---------- */
  ProductSection.prototype.initQuantity = function () {
    this.root.querySelectorAll('[data-qty-input]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10);
          input.value = Math.max(1, v);
        });
      });
    });
  };

  /* ---------- Bundle & Save ---------- */
  ProductSection.prototype.initBundle = function () {
    var self = this;
    if (!this.bundle) return;
    this.tiers = Array.prototype.slice.call(this.bundle.querySelectorAll('[data-bundle-tier]'));
    if (this.tiers.length === 0) { this.bundle = null; return; }

    if (!this.bundle.querySelector('[data-bundle-tier].is-selected')) this.selectTier(this.tiers[0], true);

    this.tiers.forEach(function (tier) {
      tier.addEventListener('click', function (e) {
        if (e.target.closest('select')) {
          if (!tier.classList.contains('is-selected')) self.selectTier(tier);
          return;
        }
        self.selectTier(tier);
      });
      tier.addEventListener('keydown', function (e) {
        if (e.target !== tier) return;
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.selectTier(tier); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          var i = self.tiers.indexOf(tier) + (e.key === 'ArrowDown' ? 1 : -1);
          var target = self.tiers[(i + self.tiers.length) % self.tiers.length];
          self.selectTier(target);
          target.focus();
        }
      });
      tier.querySelectorAll('[data-bundle-row]').forEach(function (row, rowIndex) {
        row.addEventListener('change', function (e) {
          var sel = e.target.closest('[data-row-option]');
          var optionIndex = sel ? parseInt(sel.getAttribute('data-row-option'), 10) : -1;
          var isColor = optionIndex >= 0 && optionIndex === self.colorIndex;
          self.updateRow(row);
          // Each item keeps its own size and color; choosing a color also previews it in the photos
          if (isColor) self.previewColor(sel.value);
          if (rowIndex === 0 && tier.classList.contains('is-selected') && optionIndex >= 0) {
            self.currentOptions[optionIndex] = sel.value;
          }
          self.updateTier(tier);
          if (tier.classList.contains('is-selected')) self.refreshVariant(isColor);
        });
      });
    });

    this.tiers.forEach(function (t) { self.updateTier(t); });
    this.updateBundleButton();
  };

  ProductSection.prototype.selectTier = function (tier, silent) {
    var self = this;
    var previous = this.bundle.querySelector('[data-bundle-tier].is-selected');
    this.tiers.forEach(function (t) {
      var on = t === tier;
      t.classList.toggle('is-selected', on);
      t.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    // Carry the chosen options over to the newly selected tier
    // Keep what the customer already chose: item #1 stays #1, #2 stays #2, new items copy #1
    if (previous && previous !== tier) {
      var prevRows = Array.prototype.slice.call(previous.querySelectorAll('[data-bundle-row]'));
      if (prevRows.length) {
        tier.querySelectorAll('[data-bundle-row]').forEach(function (row, k) {
          var v = self.rowVariant(prevRows[k] || prevRows[0]);
          if (!v) return;
          row.querySelectorAll('[data-row-option]').forEach(function (sel) {
            var i = parseInt(sel.getAttribute('data-row-option'), 10);
            if (v.options[i] !== undefined) sel.value = v.options[i];
          });
          self.updateRow(row);
        });
      }
    }
    this.updateTier(tier);
    if (!silent) this.updateBundleButton();
  };

  ProductSection.prototype.rowVariant = function (row) {
    var selects = row.querySelectorAll('[data-row-option]');
    if (selects.length === 0) return this.product.variants[0];
    var options = [];
    selects.forEach(function (sel) { options[parseInt(sel.getAttribute('data-row-option'), 10)] = sel.value; });
    return this.findVariant(options);
  };

  ProductSection.prototype.updateRow = function (row) {
    var v = this.rowVariant(row);
    var img = row.querySelector('.bundle__variant-img');
    if (img && v && v.featured_image && v.featured_image.src) {
      var src = v.featured_image.src;
      if (/^(https?:)?\/\//.test(src)) src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.removeAttribute('srcset');
      img.src = src;
    }
  };

  ProductSection.prototype.tierVariants = function (tier) {
    var self = this;
    var rows = tier.querySelectorAll('[data-bundle-row]');
    var qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
    if (rows.length === 0) {
      var base = this.findVariant(this.currentOptions) ||
        this.product.variants.find(function (v) { return v.available; }) || this.product.variants[0];
      var list = [];
      for (var i = 0; i < qty; i++) list.push(base);
      return list;
    }
    return Array.prototype.map.call(rows, function (row) { return self.rowVariant(row); });
  };

  ProductSection.prototype.updateTier = function (tier) {
    var variants = this.tierVariants(tier);
    var pct = parseInt(tier.getAttribute('data-discount'), 10) || 0;
    var total = 0;
    var compare = 0;
    var valid = true;
    variants.forEach(function (v) {
      if (!v) { valid = false; return; }
      total += v.price;
      compare += Math.max(v.compare_at_price || v.price, v.price);
    });
    if (!valid) return;
    var discount = Math.floor((total * pct) / 100);
    var price = total - discount;
    var fixed = parseInt(tier.getAttribute('data-fixed-price'), 10);
    if (!isNaN(fixed) && fixed > 0) price = fixed;
    var savings = compare - price;

    var priceEl = tier.querySelector('[data-tier-price]');
    var compareEl = tier.querySelector('[data-tier-compare]');
    var subEl = tier.querySelector('[data-tier-subtitle]');
    if (priceEl) priceEl.textContent = formatMoney(price);
    if (compareEl) compareEl.textContent = compare > price ? formatMoney(compare) : '';
    if (subEl && tier.getAttribute('data-custom-subtitle') !== 'true') {
      subEl.textContent = savings > 0 ? (this.bundle.getAttribute('data-save-text') + ' ' + formatMoney(savings)) : '';
    }
  };

  ProductSection.prototype.updateBundleButton = function () {
    var tier = this.bundle && this.bundle.querySelector('[data-bundle-tier].is-selected');
    if (!tier) return;
    var variants = this.tierVariants(tier);
    var missing = variants.some(function (v) { return !v; });
    var soldOut = variants.some(function (v) { return v && !v.available; });
    if (missing) this.setButton(false, theme.strings.unavailable);
    else if (soldOut) this.setButton(false, theme.strings.soldOut);
    else this.setButton(true);
    if (!missing && variants[0] && this.idInput) this.idInput.value = variants[0].id;
  };

  /* ---------- Add to cart ---------- */
  ProductSection.prototype.initForm = function () {
    var self = this;
    if (!this.form) return;
    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (self.addButton && self.addButton.disabled) return;
      var items = [];

      if (self.bundle) {
        var tier = self.bundle.querySelector('[data-bundle-tier].is-selected');
        var counts = {};
        var order = [];
        self.tierVariants(tier).forEach(function (v) {
          if (!v) return;
          if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
          counts[v.id] += 1;
        });
        order.forEach(function (id) { items.push({ id: id, quantity: counts[id] }); });
      } else {
        var qtyInput = self.root.querySelector('input[name="quantity"]');
        items.push({
          id: parseInt(self.idInput.value, 10),
          quantity: qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1
        });
      }

      if (items.length === 0) return;
      if (self.errorEl) { self.errorEl.hidden = true; self.errorEl.textContent = ''; }
      if (self.addButton) self.addButton.classList.add('is-loading');

      addItems(items)
        .then(function () { return afterAdd(self.addButton ? self.addButton.getAttribute('data-after-add') : 'drawer'); })
        .catch(function (err) {
          if (self.errorEl) { self.errorEl.textContent = err.message; self.errorEl.hidden = false; }
        })
        .then(function () { if (self.addButton) self.addButton.classList.remove('is-loading'); });
    });
  };

  document.querySelectorAll('[data-product-section]').forEach(function (el) { new ProductSection(el); });

  /* =========================================================
     Video slider
     ========================================================= */
  function VideoSlider(root) {
    var track = root.querySelector('[data-video-track]');
    if (!track) return;
    var cards = Array.prototype.slice.call(track.querySelectorAll('.video-card'));

    function centerIndex() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function update() {
      var idx = centerIndex();
      cards.forEach(function (c, i) {
        c.classList.toggle('is-center', i === idx);
        var video = c.querySelector('video');
        if (!video) return;
        if (i === idx && root.dataset.visible === 'true') {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function scrollToIndex(i) {
      var card = cards[Math.max(0, Math.min(cards.length - 1, i))];
      if (!card) return;
      track.scrollTo({ left: card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2, behavior: 'smooth' });
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    var prev = root.querySelector('[data-slider-prev]');
    var next = root.querySelector('[data-slider-next]');
    if (prev) prev.addEventListener('click', function () { scrollToIndex(centerIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(centerIndex() + 1); });

    cards.forEach(function (card, i) {
      var video = card.querySelector('video');
      if (video) {
        video.muted = true;
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');
      }
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-video-sound]')) {
          if (!video) return;
          video.muted = !video.muted;
          card.classList.toggle('is-unmuted', !video.muted);
          return;
        }
        scrollToIndex(i);
      });
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          root.dataset.visible = entry.isIntersecting ? 'true' : 'false';
          update();
        });
      }, { threshold: 0.3 }).observe(root);
    } else {
      root.dataset.visible = 'true';
    }

    // Start centered on the 2nd card when possible, like the reference layout
    requestAnimationFrame(function () {
      if (cards.length > 2) {
        var card = cards[1];
        track.scrollLeft = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
      }
      update();
    });
  }

  document.querySelectorAll('[data-video-slider]').forEach(function (el) { new VideoSlider(el); });

  /* Re-init when sections are edited in the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    target.querySelectorAll('[data-product-section]').forEach(function (el) { new ProductSection(el); });
    target.querySelectorAll('[data-video-slider]').forEach(function (el) { new VideoSlider(el); });
  });
})();
